import Button from 'components/Button';
import DataTable from './DataTable';
import CommonDataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListWrapper from 'components/ListWrapper';
import SearchInput from 'components/SearchInput';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';

import useTeams, {OnsiteWorkerScreenTabs} from './useTeams';

import styles from './Teams.module.scss';
import {DataTableSchemaItem} from 'types';
import {DragDropContext} from 'react-beautiful-dnd';
import ListTabs from './ListTabs';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'dropdown',
    header: '',
    sortable: false,
    colWidth: '40px',
  },
  {
    dataKey: 'name',
    header: '',
    sortable: false,
  },
  // {
  //   dataKey: 'members',
  //   header: 'Team Members',
  // },
  // {
  //   dataKey: 'model',
  //   header: 'Vehicle Name',
  //   sortable: true,
  // },
  // {
  //   dataKey: 'travel_method',
  //   header: 'Travel method',
  //   align: 'center',
  //   sortable: false,
  // },
  {
    dataKey: 'view',
    header: '',
    align: 'right',
  },
];

const SUB_SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'full_name',
    header: 'Full Name',
  },
  {
    dataKey: 'field_role',
    header: 'Role',
  },
  {
    dataKey: 'phone',
    header: 'Phone number',
  },
  // {
  //   dataKey: 'active',
  //   header: 'Active',
  // },
  {dataKey: 'view', header: '', colWidth: '150px'},
];

const WORKERS_SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'full_name',
    header: 'Full Name',
  },
  {
    dataKey: 'driver_field_role',
    header: 'Role',
  },
  {
    dataKey: 'team',
    header: 'Team',
  },
  {
    dataKey: 'phone',
    header: 'Phone number',
  },

  {dataKey: 'view', header: '', colWidth: '150px'},
];

const tabs: {title: string; value: OnsiteWorkerScreenTabs}[] = [
  {title: 'Workers', value: 'workers_tab'},
  {title: 'Teams', value: 'teams_tab'},
];

function Teams() {
  const {
    teams,
    workers,
    isLoading,
    isWorkersLoading,
    sortBy,
    sortOrder,
    activeTab,
    onSort,
    keyWord,
    setKeyWord,
    showSubMembers,
    setSelectedRows,
    selectedRows,
    onAddMemberClick,
    handleDragEnd,
    setActiveTab,
  } = useTeams();

  const isWorkersTab = activeTab === 'workers_tab';
  return (
    <>
      <PageHeader>
        <Typography variant="h2">Onsite Workers</Typography>
        <Button
          to={isWorkersTab ? '/people/employees/new' : '/people/teams/new'}
          component="a"
        >
          {isWorkersTab ? 'New Worker' : 'New Team'}
        </Button>
      </PageHeader>
      <ListTabs
        className={styles.tabContainer}
        tabs={tabs}
        activeTabValue={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === 'workers_tab' && (
        <ListWrapper>
          <CommonDataTable
            schema={WORKERS_SCHEMA}
            data={workers}
            loading={isWorkersLoading}
          />
        </ListWrapper>
      )}
      {activeTab === 'teams_tab' && (
        <ListWrapper>
          <ListActionsWrapper className={styles.list_header}>
            <SearchInput
              value={keyWord}
              onChange={(val) => {
                setKeyWord(val.target.value);
                sessionStorage.setItem(`search_team`, val.target.value);
              }}
              size="sm"
            />
          </ListActionsWrapper>
          <DragDropContext
            dragHandleUsageInstructions="drag"
            onDragEnd={handleDragEnd}
          >
            <DataTable
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={onSort}
              showSubMembers={showSubMembers}
              selectedRows={selectedRows}
              data={teams as any}
              onAddMemberClick={onAddMemberClick}
              schema={SCHEMA}
              subSchema={SUB_SCHEMA}
              loading={isLoading}
              selectable={false}
              onClick={(row) =>
                setSelectedRows((pr) => (pr !== row.id ? row.id : 0))
              }
            />
          </DragDropContext>
        </ListWrapper>
      )}
    </>
  );
}

export default Teams;
